// Utility function to format the currency to a specific location
export default function formatPrice(number = 0) {
    // Converts the number to a string formatted with semicolons
    const formattedNumber = number.toLocaleString(
        'pt-BR',
        {
            minimumFractionDigits: 2
        }
    );

    // Returns the formatted string with the real symbol (R$) at the beginning
    return `${formattedNumber}`;
}
